import { render, staticRenderFns } from "./dat-lich-dong-tien.vue?vue&type=template&id=5fdf484c&scoped=true"
import script from "./dat-lich-dong-tien.vue?vue&type=script&lang=js"
export * from "./dat-lich-dong-tien.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdf484c",
  null
  
)

export default component.exports